import type { ProductT } from '../types';

export const getOptionByProduct = (
  productMap: Map<string, ProductT>,
  productAlias: string,
) => {
  return productMap.get(productAlias)?.options?.map((op) => {
    return {
      type: 'option',
      id: op.id,
      name: op.option_name,
    };
  });
};

export const getProductByBrand = (
  productMap: Map<string, ProductT>,
  brandAlias: string,
) => {
  return productMap
    .values()
    .toArray()
    .filter((product) => {
      return product.brand_id === brandAlias;
    })
    .map((product) => {
      return {
        type: 'product',
        id: product.alias,
        name: product.product_name,
      };
    });
};

export const getProductByLine = (
  productMap: Map<string, ProductT>,
  lineAlias: string,
) => {
  return productMap
    .values()
    .toArray()
    .filter((product) => {
      return product.line_id === lineAlias;
    })
    .map((product) => {
      return {
        type: 'product',
        id: product.alias,
        name: product.product_name,
      };
    });
};
